module.exports = __webpack_public_path__ + "static/media/app-store-connect-graphs-reduced.fa4ac704.webp";